import { render, staticRenderFns } from "./UserTextRecommendationPreview.vue?vue&type=template&id=611364b8&scoped=true"
import script from "./UserTextRecommendationPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserTextRecommendationPreview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserTextRecommendationPreview.vue?vue&type=style&index=0&id=611364b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611364b8",
  null
  
)

export default component.exports